import React, { Component, Fragment } from "react";
import Header from "../partials/Header";
import Footer from "../partials/Footer";
import {
  Col,
  Container,
  Row,
  FormGroup,
  Label,
  Form,
  Button,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Spinner,
  Input,
} from "reactstrap";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import {
  removeGameFromCard,
  fetchGames,
  addGamesToUser,
} from "../../redux/actions/gameActions";
import { MdLock, MdLockOutline } from "react-icons/md";
import moment from "moment";
import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
let stripePromise = loadStripe(`pk_test_lwonScrq5V5ZsapncqSHJGU800SqQGPn1s`);
export class PaymentPurchase extends Component {
  total = 0;
  state = {
    payment: "credit"
  };
  componentDidMount() {
    this.props.fetchGames();
  }
  noOfItemsInCart = () => {
    let cart = JSON.parse(localStorage.getItem("cart"));
    if (cart != null) return cart.length;
    return 0;
  };
  getGamesInCart = () => {
    let cart = JSON.parse(localStorage.getItem("cart"));
    let { game } = this.props;
    let gamesInCart = -1;
    console.log(cart, game);
    if (game.games != -1 && game.games != null && cart != null) {
      gamesInCart = [];
      this.total = 0;
      for (let cartItem of cart) {
        let obj = game.games.find((game) => game.id == cartItem);
        if (obj != null) gamesInCart.push(obj);
        this.total += obj.price
      }
    }
    return gamesInCart;
  };

  render() {
    var { loading, bought } = this.props;
    if (bought) {
      return <Redirect to="/my-games" />;
    }
    if (this.noOfItemsInCart() == 0) {
      return <Redirect to="/" />;
    }
    return (
      <Elements stripe={stripePromise}>
        <ElementsConsumer>
          {({ elements, stripe }) => (
            <Fragment>
              <Header
                {...this.props}
                path={["Home", "Cart"]}
                heading="Payment"
              />
              <Container className="margin-top-fix mb-5 text-white-1">
                <Form
                  onSubmit={async (e) => {
                    e.preventDefault();
                    if (this.state.payment == "paypal") {
                    } else {
                      const cardElement = await elements.getElement(
                        CardNumberElement
                      );
                      const cardElement2 = await elements.getElement(
                        CardExpiryElement
                      );
                      const cardElement3 = await elements.getElement(
                        CardCvcElement
                      );

                      const { error, paymentMethod } =
                        await stripe.createPaymentMethod({
                          type: "card",
                          card: cardElement,
                          card: cardElement2,
                          card: cardElement3,
                        });

                      if (error) {
                        alert("Card details not added", "danger");
                      } else {
                        console.log("[PaymentMethod]", paymentMethod);
                        const result = await stripe.createToken(cardElement);
                        console.log(result);
                        if (result.error) {
                          alert(result.error.message, "danger");
                          console.log(result);
                          return;
                        }
                        await this.props.addGameToUser({
                          stripeToken: result.token.id,
                          productName: "Game Name",
                          planId: "Game Buy",
                        });
                        //   this.props.history.push("/download-qr");
                      }
                    }
                  }}
                >
                  <Row className="pay-purchase-container bg-dark-1 justify-content-center">
                    <Col xl={6} lg={9} md={10} xs={11}>
                      <h5>Payment Method</h5>
                      <div className="pay-method-container bg-dark-2 mt-4">
                        <Row className="justify-content-between mt-3">
                          <Col lg={4} md={3} sm={3} className="d-flex mb-3">
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="radio"
                                  name="radio1"
                                  checked={this.state.payment == "paypal"}
                                  onClick={(e) => {
                                    this.setState({ payment: "paypal" });
                                  }}
                                />{" "}
                                Paypal
                              </Label>
                            </FormGroup>
                          </Col>
                          <Col lg={3} md={3} sm={4} xs={5}>
                            <div className="pay-logo paypal-logo"></div>
                          </Col>

                          <Col xl={8} lg={8} md={7} sm={6} className="d-flex">
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="radio"
                                  name="radio1"
                                  checked={this.state.payment == "credit"}
                                  onClick={(e) => {
                                    this.setState({ payment: "credit" });
                                  }}
                                />{" "}
                                Credit Card Or Debit Card
                              </Label>
                            </FormGroup>{" "}
                          </Col>
                          <Col xl={4} lg={3} md={4} sm={4} xs={6}>
                            <div className="pay-logo visa-logo"></div>
                          </Col>
                        </Row>
                        <div
                          hidden={this.state.payment != "credit"}
                          className="card-container"
                        >
                          <FormGroup>
                            <Label>Card Number</Label>
                            <div
                              className="form-control mt-2 d-flex"
                              style={{ justifyContent: "space-between" }}
                            >
                              <i className="fas fa-credit-card text-purple-1" />
                              <div style={{ flexBasis: "80%" }}>
                                <CardNumberElement
                                  required
                                  options={{
                                    placeholder: "1234 1234 1234 1234 ",
                                    style: {
                                      base: {
                                        backgroundColor: "#232733 ",
                                        color: "#ffffff",
                                        fontSize: "16px",
                                        // color: "#000000",
                                        // "::placeholder": {
                                        //   color: "#CC4F03",
                                        // },
                                      },
                                      invalid: {
                                        color: "#9e2146",
                                      },
                                    },
                                  }}
                                />
                              </div>
                            </div>

                            {/* <input
                              type="number"
                              className="form-control mt-2"
                              placeholder="1235 5675 8971 4567"
                              style={{ borderRadius: 16 }}
                              required
                            /> */}
                          </FormGroup>
                          <Row className="justify-content-start mt-3">
                            <Col lg={5} md={6}>
                              <FormGroup>
                                <Label>Expiry Date</Label>
                                <div
                                  className="form-control mt-2 d-flex"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <i className="fas fa-calendar text-purple-1" />
                                  <div style={{ flexBasis: "80%" }}>
                                    <CardExpiryElement
                                      required
                                      options={{
                                        placeholder: "MM/YY",
                                        style: {
                                          base: {
                                            backgroundColor: "#232733 ",
                                            color: "#ffffff",
                                            fontSize: "16px",
                                            // color: "#000000",
                                            // "::placeholder": {
                                            //   color: "#CC4F03",
                                            // },
                                          },
                                          invalid: {
                                            color: "#9e2146",
                                          },
                                        },
                                      }}
                                    />
                                  </div>{" "}
                                </div>
                                {/* <input
                                  type="number"
                                  className="form-control mt-2"
                                  placeholder="MM/YY"
                                  style={{ borderRadius: 16 }}
                                  required
                                /> */}
                              </FormGroup>
                            </Col>
                            <Col lg={5} md={6}>
                              <FormGroup>
                                <Label>CVC/CVV</Label>
                                <div
                                  className="form-control mt-2 d-flex"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  {/* <i className="far fa-lock text-purple-1" /> */}
                                  <MdLockOutline
                                    className="text-purple-1"
                                    fontSize={20}
                                  />
                                  <div style={{ flexBasis: "80%" }}>
                                    <CardCvcElement
                                      required
                                      options={{
                                        placeholder: "...",
                                        style: {
                                          base: {
                                            backgroundColor: "#232733 ",
                                            color: "#ffffff",
                                            fontSize: "16px",
                                            // color: "#000000",
                                            // "::placeholder": {
                                            //   color: "#CC4F03",
                                            // },
                                          },
                                          invalid: {
                                            color: "#9e2146",
                                          },
                                        },
                                      }}
                                    />
                                  </div>
                                </div>
                                {/* <input
                                  type="number"
                                  className="form-control mt-2"
                                  placeholder="..."
                                  style={{ borderRadius: 16 }}
                                  required
                                /> */}
                              </FormGroup>
                            </Col>
                          </Row>
                          <div className="card-remember">
                            <FormGroup className="d-flex">
                              {/* <i className="mt-1 fas fa-lock text-purple-1" /> */}
                              <MdLock className="text-purple-1" fontSize={20} />
                              <p className="ms-4 text-grey-1">
                                Your transaction is secured with SSL encryption.
                              </p>
                            </FormGroup>
                            <FormGroup className="d-flex">
                              <input type="checkbox" className="mt-1" />
                              <p className="ms-4 text-grey-1">
                                Remember this for future payments
                              </p>
                            </FormGroup>
                            <FormGroup className="d-flex">
                              <input
                                type="checkbox"
                                className="mt-1"
                                required
                              />
                              <p className="ms-4 text-grey-1">
                                I read and agree to
                                <span className="text-purple-1">
                                  {" "}
                                  <b>
                                    <u>Terms And Conditions</u>
                                  </b>{" "}
                                </span>{" "}
                                and
                                <span className="text-purple-1">
                                  {" "}
                                  <b>
                                    <u>Refund Policy</u>
                                  </b>
                                </span>
                              </p>
                            </FormGroup>
                          </div>
                          {/* <Col lg={7}>
                                            <Button block className="w-100 bg-purple-1 border-0 py-4 " style={{ borderRadius: 16 }}>Edit Card</Button>
                                        </Col> */}
                        </div>
                      </div>
                    </Col>
                    <Col xl={5} lg={7} md={8} xs={9} className="pay-summary">
                      <h5>Summary</h5>
                      <Row>
                        <div className="pay-summary-container bg-dark-2 mt-3">
                          <Row>
                            {this.getGamesInCart() == -1 ? (
                              <div className="d-flex align-items-center justify-content-center my-5">
                                <Spinner color="light" />
                              </div>
                            ) : (
                              this.getGamesInCart().map((game) => (
                                <>
                                  <Col lg={5} md={5}>
                                    <div
                                      className="checkout-img game-img-5"
                                      style={{
                                        backgroundImage: `url(${game.img})`,
                                      }}
                                    ></div>
                                  </Col>
                                  <Col lg={7} md={7}>
                                    <div className="text-white-1 checkout-img-desc">
                                      <CardBody>
                                        <div className="d-flex">
                                          <CardTitle tag="h6">
                                            {game.title}
                                          </CardTitle>
                                          <div
                                            className="pointer ms-auto"
                                            onClick={(e) =>
                                              this.props.removeGameFromCart(
                                                game.id
                                              )
                                            }
                                          >
                                            <i
                                              className="fas fa-trash p-1"
                                              style={{
                                                color: "#FFC144",
                                                border: "2px solid #FFC144",
                                                borderRadius: 8,
                                              }}
                                            ></i>
                                          </div>
                                        </div>
                                        <CardSubtitle
                                          tag="h6"
                                          className="mb-2 text-muted mt-3"
                                        >
                                          {game.address}
                                        </CardSubtitle>
                                        <CardSubtitle
                                          tag="h6"
                                          className="mb-2 text-muted mt-3"
                                        >
                                          {moment(
                                            game.start_date.toDate()
                                          ).format("DD MMM YYYY")}
                                        </CardSubtitle>
                                        <div className="d-flex mt-2">
                                          <p>Price:</p>
                                          <p className="px-2 text-green-1">
                                            ${game.price}
                                          </p>
                                        </div>
                                      </CardBody>
                                    </div>
                                  </Col>
                                </>
                              ))
                            )}
                          </Row>
                          <hr className="line4 mt-0" />
                          <div className="d-flex ">
                            <CardSubtitle tag="h6" className="text-muted">
                              Discount Coupon :
                            </CardSubtitle>
                            <CardSubtitle tag="h6" className=" px-5 text-muted">
                              $ 0
                            </CardSubtitle>
                          </div>
                          <div className="d-flex mt-2">
                            <p>Total :</p>
                            <p className="px-3 text-red-1">$ {this.total}</p>
                          </div>
                          {/* <Button block className="w-100 bg-purple-1 border-0 py-4 " style={{ borderRadius: 16 }}>Modify Cart</Button> */}
                        </div>
                        <Row className="justify-content-center mt-4">
                          <Col lg={8}>
                            <Button
                              type="submit"
                              block
                              disabled={loading}
                              className="w-100 bg-purple-1 border-0 py-4 "
                              style={{ borderRadius: 16 }}
                            >
                              {loading ? <Spinner size="sm" /> : "Checkout"}
                            </Button>
                          </Col>
                        </Row>
                      </Row>
                    </Col>
                  </Row>
                </Form>
              </Container>
              <Footer />
            </Fragment>
          )}
        </ElementsConsumer>
      </Elements>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    game: state.game,
    loading: state.game.loading,
    bought: state.game.bought,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchGames: () => dispatch(fetchGames()),
    removeGameFromCart: (id) => dispatch(removeGameFromCard(id)),
    addGameToUser: (details) => dispatch(addGamesToUser(details)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentPurchase);
